import { ignoreMinutesIfZero } from 'components/organisms/resource-management/utils/dates';
import { TranslationKey, useTranslate } from 'hooks/use-translation';

interface Props {
  translate: ReturnType<typeof useTranslate>;
  key: string;
  name?: string;
  startDateString: string;
  endDateString: string;
  hasDates: string | boolean;
  availableMinutes: number;
}

export const userSummaryTemplateForDayView = ({
  translate,
  key,
  name,
  startDateString,
  endDateString,
  hasDates,
  availableMinutes,
}: Props): string =>
  translate(
    `resource_management.user_summary.tooltip.day.${key}` as TranslationKey,
    {
      name,
      startDate: startDateString,
      endDate: endDateString,
      time: ignoreMinutesIfZero(Math.abs(availableMinutes)),
      hasDates,
      strong: (chunks) => `<strong>${chunks}</strong>`,
      duration: (chunks) =>
        `<strong style="color:${
          availableMinutes > 0 ? 'var(--green-20)' : 'var(--red-30)'
        }">${chunks}</strong>`,
    },
  );
